import axios from 'axios';

// Create axios instance
const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',
    headers: {
        'Content-Type': 'application/json',
    },
});

export const burnRequestsAPI = {
    // Get all burn requests
    getAllBurnRequests: async (params = {}) => {
        try {
            const response = await api.get('/api/burn-requests', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching burn requests:', error);
            throw error;
        }
    },

    // Get burn request by ID
    getBurnRequestById: async (id) => {
        try {
            const response = await api.get(`/api/burn-requests/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching burn request:', error);
            throw error;
        }
    },

    // Create new burn request
    createBurnRequest: async (data) => {
        try {
            const response = await api.post('/api/burn-requests', data);
            return response.data;
        } catch (error) {
            console.error('Error creating burn request:', error);
            throw error;
        }
    },

    // Update burn request status (approve/reject)
    updateBurnRequestStatus: async (id, data) => {
        try {
            const response = await api.put(`/api/burn-requests/${id}/status`, data);
            return response.data;
        } catch (error) {
            console.error('Error updating burn request status:', error);
            throw error;
        }
    },

    // Approve burn request
    approveBurnRequest: async (id, data = {}) => {
        try {
            const approvalData = {
                status: 'Approved',
                transactionHash: data.transactionHash || `0x${Math.random().toString(16).substr(2, 64)}`,
                actualTokensBurned: data.actualTokensBurned,
                notes: data.notes || 'Burn request approved and tokens burned successfully',
                ...data
            };

            const response = await api.put(`/api/burn-requests/${id}/status`, approvalData);
            return response.data;
        } catch (error) {
            console.error('Error approving burn request:', error);
            throw error;
        }
    },

    // Reject burn request
    rejectBurnRequest: async (id, data) => {
        try {
            const rejectionData = {
                status: 'Rejected',
                rejectionReason: data.rejectionReason,
                notes: data.notes || '',
                ...data
            };

            const response = await api.put(`/api/burn-requests/${id}/status`, rejectionData);
            return response.data;
        } catch (error) {
            console.error('Error rejecting burn request:', error);
            throw error;
        }
    },

    // Get burn requests by bond ID
    getBurnRequestsByBondId: async (bondId) => {
        try {
            const response = await api.get('/api/burn-requests', {
                params: { bondId }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching burn requests by bond ID:', error);
            throw error;
        }
    },

    // Get burn requests by issuer
    getBurnRequestsByIssuer: async (issuer) => {
        try {
            const response = await api.get('/api/burn-requests', {
                params: { issuer }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching burn requests by issuer:', error);
            throw error;
        }
    },

    // Get pending burn requests
    getPendingBurnRequests: async () => {
        try {
            const response = await api.get('/api/burn-requests', {
                params: { status: 'Pending' }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching pending burn requests:', error);
            throw error;
        }
    },

    // Get burn request statistics
    getBurnRequestStats: async () => {
        try {
            const response = await api.get('/api/burn-requests/stats');
            return response.data;
        } catch (error) {
            console.error('Error fetching burn request statistics:', error);
            throw error;
        }
    },

    // Delete burn request (admin only)
    deleteBurnRequest: async (id) => {
        try {
            const response = await api.delete(`/api/burn-requests/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting burn request:', error);
            throw error;
        }
    }
};

export default burnRequestsAPI;
